import React, { } from "react"
import { View, Text, Image } from "react-native"

import { cap1stChar, getImagePath } from "../../services/CommonUtils"

import { LocationIcon } from "../CommonWidget/Icons"

import AppStyles from "../../../AppStyles"
import TextStyle from "../../../TextStyle"
import Colors from "../../constants/AppColors"

export function PharmacyCity(city) {
    city = cap1stChar(city)
    return <View style={[AppStyles.flexRowCenter, AppStyles.border12, AppStyles.mediumShadow,
    AppStyles.mr8, AppStyles.mt10, {
        backgroundColor: Colors.skyBlue.bg, paddingHorizontal: 6, paddingVertical: 4,
    }]}><LocationIcon tintColor={Colors.primary} resize={12 / 18} />
        <Text style={[TextStyle.text10b, { marginLeft: 6 }]}>
            {city}</Text>
    </View>
}

export function PharmacyDiscount(discount) {
    return <View style={[AppStyles.flexRowCenter, AppStyles.border12, AppStyles.mediumShadow,
    AppStyles.mr8, AppStyles.mt10, {
        backgroundColor: Colors.orange.bg, paddingHorizontal: 6, paddingVertical: 4,
    }]}><Image style={{ width: 12, height: 12 }} source={{ uri: getImagePath('/images/icons/percent.svg'), width: 15, height: 15 }}></Image>
        <Text style={[TextStyle.text10b, { marginLeft: 6, color: Colors.orange.text }]}>
            Up to {discount}% OFF</Text>
    </View>
}


export function HomeDelivery() {
    return <View style={[AppStyles.flexRowCenter, AppStyles.border12, AppStyles.mediumShadow,
    AppStyles.mr8, AppStyles.mt10, {
        backgroundColor: Colors.green.lightPrimary, paddingHorizontal: 6, paddingVertical: 4,
    }]}><Image style={{ width: 12, height: 12 * 11 / 15 }} source={{ uri: getImagePath("/images/icons/home_delivery.svg") }}></Image>
        <Text style={[TextStyle.text10b, { marginLeft: 6, color: Colors.green.primary }]}>
            Home Delivery</Text>
    </View>
}

export function InStorePickUp() {
    return <View style={[AppStyles.flexRowCenter, AppStyles.border12, AppStyles.mediumShadow,
    AppStyles.mr8, AppStyles.mt10, {
        backgroundColor: Colors.purple.bg, paddingHorizontal: 6, paddingVertical: 4,
    }]}><Image style={{ width: 15, height: 14 }} source={{ uri: getImagePath("/images/icons/in_store_pickup.svg") }}></Image>
        <Text style={[TextStyle.text10b, { marginLeft: 6, color: Colors.purple.text }]}>
            In-Store Pickup</Text>
    </View>
}